import { Link } from "react-router-dom";
import { tachLienKet } from "../lib/lienKetChu.js";
import { tuDienTheoSlug } from "../data/glossary.js";

/** Hiện một chuỗi có cú pháp [[slug|chữ]] thành chữ kèm liên kết nội bộ. */
export default function DoanVan({ chu }) {
  return tachLienKet(chu).map((m, i) =>
    m.href ? (
      <Link key={i} to={m.href}>
        {m.chu || (m.slug && tuDienTheoSlug(m.slug)?.term) || m.href}
      </Link>
    ) : (
      m.chu
    ),
  );
}
